import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

const KEY_TO_LABEL = {
  analysisType: "Analysis Type",
  openingYear: "Opening Year",
  designYear: "Design Year",
};

export default function GlobalInputReport({ projectData }) {
  return (
    <Grid container spacing={2}>
      {Object.entries(projectData.globalInputData)?.map(([key, value]) => {
        if (key in KEY_TO_LABEL) {
          return (
            <React.Fragment key={key}>
              <Grid item sx={{ fontWeight: "700", textAlign: "right" }} xs={6}>
                {KEY_TO_LABEL[key]}
              </Grid>
              <Grid sx={{ textAlign: "left" }} item xs={6}>
                {value}
              </Grid>
            </React.Fragment>
          );
        } else {
          return "";
        }
      })}
    </Grid>
  );
}

GlobalInputReport.propTypes = {
  projectData: PropTypes.shape({
    openingYear: PropTypes.string,
    designYear: PropTypes.string,
  }).isRequired,
};
